import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Spinner,
  Row,
  Col,
  Table,
  Badge,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import Footer from "components/Footers/Footer";
import {
  FaInfoCircle,
  FaCalculator,
  FaTrash,
  FaPrint,
  FaTimesCircle,
} from "react-icons/fa";

const IsKazaTazminatHesaplama = () => {
  // State
  const [formData, setFormData] = useState({
    cinsiyet: "",
    yas: "",
    gelir: "",
    maluliyetOrani: "",
    isverenKusurOrani: "",
    calisanKusurOrani: "",
    telefon: "",
  });

  const [sonuc, setSonuc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hata, setHata] = useState(null);
  const [formGosterildi, setFormGosterildi] = useState(true);
  const [validationErrors, setValidationErrors] = useState({});

  const currentUser = "ARS Hukuk";
  const [currentDate, setCurrentDate] = useState(
    new Date().toLocaleString("tr-TR")
  );

  // Effects
  useEffect(() => {
    AOS.init();
    const t = setInterval(
      () => setCurrentDate(new Date().toLocaleString("tr-TR")),
      1000
    );
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const targetLink = document.querySelector('a[data-gt-lang="tr"]');
    if (targetLink) {
      targetLink.click();
      const imgElement = document.querySelector(".gt-current-lang img");
      const newImgSrc = "https://cdn.gtranslate.net/flags/32/tr.png";
      if (imgElement) {
        imgElement.src = newImgSrc;
        imgElement.width = "32";
        imgElement.height = "32";
      }
    }
  }, []);

  // Handlers
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (validationErrors[name])
      setValidationErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.cinsiyet) errors.cinsiyet = "Cinsiyet seçimi zorunludur";
    if (!formData.telefon) errors.telefon = "Telefon numarası zorunludur";

    if (!formData.yas) errors.yas = "Yaş bilgisi zorunludur";
    else {
      const yas = parseInt(formData.yas, 10);
      if (isNaN(yas)) errors.yas = "Lütfen geçerli bir yaş giriniz";
      else if (yas < 18 || yas > 65)
        errors.yas = "Yaş 18 ile 65 arasında olmalıdır";
    }

    if (!formData.gelir) errors.gelir = "Gelir bilgisi zorunludur";
    else if (parseFloat(formData.gelir) <= 0)
      errors.gelir = "Gelir sıfırdan büyük olmalıdır";

    if (!formData.maluliyetOrani)
      errors.maluliyetOrani = "Maluliyet oranı zorunludur";
    else {
      const m = parseFloat(formData.maluliyetOrani);
      if (isNaN(m)) errors.maluliyetOrani = "Lütfen geçerli bir oran giriniz";
      else if (m <= 0 || m > 100)
        errors.maluliyetOrani =
          "Maluliyet oranı 0'dan büyük ve 100'den küçük olmalıdır";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      setHata("Lütfen işaretli alanları kontrol edin ve eksikleri tamamlayın.");
      return;
    }
    setLoading(true);
    setHata(null);

    try {
      // Kendi endpoint'inize veri gönder
      await fetch("https://your-api-endpoint.com/api/iskaza-tazminat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          tarih: currentDate,
        }),
      });
    } catch (error) {
      console.error("Veri kaydedilemedi:", error);
    }

    try {
      await hesaplamaSimulasyonu();
      setFormGosterildi(false);
    } catch (error) {
      setHata(error.message);
      setSonuc(null);
    } finally {
      setLoading(false);
    }
  };

  const hesaplamaSimulasyonu = () =>
    new Promise((resolve) => {
      setTimeout(() => {
        const yas = parseInt(formData.yas, 10);
        const gelir = parseFloat(formData.gelir);
        const maluliyetOrani = parseFloat(formData.maluliyetOrani) / 100;
        const isverenKusurOrani =
          parseFloat(formData.isverenKusurOrani || "0") / 100;
        const calisanKusurOrani =
          parseFloat(formData.calisanKusurOrani || "0") / 100;

        const emeklilikYasi = formData.cinsiyet === "erkek" ? 60 : 58;
        const calismaSuresi = Math.max(emeklilikYasi - yas, 0);

        const yasamBeklentisi = formData.cinsiyet === "erkek" ? 76 : 82;
        const pasifDonemSuresi = Math.max(yasamBeklentisi - emeklilikYasi, 0);

        const aktifDonemTazminat =
          gelir * maluliyetOrani * calismaSuresi * 12 * 0.85;
        const pasifDonemTazminat =
          gelir * 0.7 * maluliyetOrani * pasifDonemSuresi * 12 * 0.75;

        let maddiTazminat = aktifDonemTazminat + pasifDonemTazminat;

        const tehlikeKatsayisi = 1.3;
        maddiTazminat =
          maddiTazminat * isverenKusurOrani * (1 - calisanKusurOrani);
        const maneviTazminat = maddiTazminat * 0.4 * tehlikeKatsayisi;

        const toplamTazminat = maddiTazminat + maneviTazminat;
        const aylikOdeme = toplamTazminat / 60;

        setSonuc({
          hesaplamaBilgileri: {
            yas,
            cinsiyet: formData.cinsiyet,
            gelir,
            maluliyetOrani: formData.maluliyetOrani,
            isverenKusurOrani: formData.isverenKusurOrani || "0",
            calisanKusurOrani: formData.calisanKusurOrani || "0",
            telefon: formData.telefon,
          },
          tazminatDetaylari: {
            maddiTazminat: Math.round(maddiTazminat),
            maneviTazminat: Math.round(maneviTazminat),
            toplamTazminat: Math.round(toplamTazminat),
            aylikOdeme: Math.round(aylikOdeme),
          },
          raporNo: `IKT-${Math.floor(Math.random() * 10000000)}`,
        });
        resolve();
      }, 800);
    });

  const formuTemizle = () => {
    setFormData({
      cinsiyet: "",
      yas: "",
      gelir: "",
      maluliyetOrani: "",
      isverenKusurOrani: "",
      calisanKusurOrani: "",
      telefon: "",
    });
    setValidationErrors({});
    setHata(null);
  };

  const yeniHesaplamayap = () => {
    setFormGosterildi(true);
    setSonuc(null);
    setHata(null);
    setValidationErrors({});
  };

  const sonucuYazdir = () => {
    if (!sonuc) return;
    const { hesaplamaBilgileri, tazminatDetaylari, raporNo } = sonuc;
    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Lütfen açılır pencere engelleyicisini devre dışı bırakın.");
      return;
    }
    printWindow.document.write(`
      <html>
      <head>
        <title>İş Kazası Tazminat Raporu</title>
        <style>
          body { font-family: 'Segoe UI', Arial, sans-serif; margin: 40px; color: #344767; line-height: 1.65; }
          .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #123274; padding-bottom: 20px; color: #123274; }
          .logo { margin-bottom: 15px; display: flex; justify-content: center; }
          .logo-circle { width: 60px; height: 60px; border-radius: 50%; background: #123274; color: white; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 24px; }
          .header h2 { font-size: 28px; margin: 15px 0 10px; font-weight: 700; }
          .header p { color: #495057; margin-top: 5px; }
          .result { border: 1px solid #e0e0e0; border-radius: 10px; padding: 30px; margin-bottom: 35px; background: #f9f9f9; box-shadow: 0 5px 15px rgba(0,0,0,0.05); }
          .result h3 { color: #123274; border-bottom: 1px solid #e0e0e0; padding-bottom: 15px; margin-bottom: 25px; font-size: 22px; font-weight: 700; }
          table { width: 100%; border-collapse: collapse; }
          th { padding: 12px; text-align: left; border-bottom: 2px solid #e0e0e0; background: #f8f9fa; color: #344767; font-weight: 700; }
          td { padding: 12px; border-bottom: 1px solid #e0e0e0; }
          .footer { margin-top: 40px; font-size: 12px; text-align: center; color: #6c757d; border-top: 1px solid #e0e0e0; padding-top: 15px; }
          .total-box { text-align: center; background: #fff; border-radius: 8px; padding: 18px; box-shadow: 0 2px 8px rgba(0,0,0,.05); margin: 20px 0; }
          .total-label { font-size: 14px; color: #6c757d; font-weight: 700; text-transform: uppercase; }
          .total-value { font-size: 28px; font-weight: 900; color: #123274; margin-top: 6px; }
        </style>
      </head>
      <body>
        <div class="header">
          
          <h2>İŞ KAZASI TAZMİNAT RAPORU</h2>
          <p>Rapor No: ${raporNo} | Tarih: ${new Date().toLocaleDateString(
      "tr-TR"
    )}</p>
        </div>

        <div class="result">
          <h3>TOPLAM TAZMİNAT</h3>
          <div class="total-box">
            <div class="total-label">Toplam Tazminat Tutarı</div>
            <div class="total-value">${tazminatDetaylari.toplamTazminat.toLocaleString(
              "tr-TR"
            )} ₺</div>
          </div>
        </div>

        <div class="result">
          <h3>HESAPLAMA PARAMETRELERİ</h3>
          <table>
            <tbody>
              <tr><th style="width:40%">Yaş</th><td>${
                hesaplamaBilgileri.yas
              } yıl</td></tr>
              <tr><th>Cinsiyet</th><td>${
                hesaplamaBilgileri.cinsiyet === "erkek" ? "Erkek" : "Kadın"
              }</td></tr>
              <tr><th>Telefon</th><td>${
                hesaplamaBilgileri.telefon || "-"
              }</td></tr>
              <tr><th>Aylık Gelir</th><td>${(+hesaplamaBilgileri.gelir).toLocaleString(
                "tr-TR"
              )} ₺</td></tr>
              <tr><th>Maluliyet Oranı</th><td>%${
                hesaplamaBilgileri.maluliyetOrani
              }</td></tr>
              <tr><th>İşveren Kusur Oranı</th><td>%${
                hesaplamaBilgileri.isverenKusurOrani
              }</td></tr>
              <tr><th>Çalışan Kusur Oranı</th><td>%${
                hesaplamaBilgileri.calisanKusurOrani
              }</td></tr>
            </tbody>
          </table>
        </div>

        <div class="result">
          <h3>TAZMİNAT DETAYLARI</h3>
          <table>
            <tbody>
              <tr><th style="width:40%">Maddi Tazminat</th><td>${tazminatDetaylari.maddiTazminat.toLocaleString(
                "tr-TR"
              )} ₺</td></tr>
              <tr><th>Manevi Tazminat</th><td>${tazminatDetaylari.maneviTazminat.toLocaleString(
                "tr-TR"
              )} ₺</td></tr>
              <tr><th>Aylık Ödeme (5 Yıl)</th><td>${tazminatDetaylari.aylikOdeme.toLocaleString(
                "tr-TR"
              )} ₺</td></tr>
              <tr><th>Toplam</th><td><strong>${tazminatDetaylari.toplamTazminat.toLocaleString(
                "tr-TR"
              )} ₺</strong></td></tr>
            </tbody>
          </table>
        </div>

        <div class="footer">
          <p>Bu rapor bilgilendirme amaçlıdır. Yasal işlemlerde kullanmadan önce bir uzmana danışınız.</p>
          <p>© ${new Date().getFullYear()} ARS Hukuk | İş Kazası Tazminat Hesaplama Raporu</p>
        </div>
      </body>
      </html>
    `);
    printWindow.document.close();
    setTimeout(() => printWindow.print(), 300);
  };

  return (
    <>
      <Helmet>
        <title>İŞ KAZASI TAZMİNAT HESAPLAMA | ARS HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="İş kazası tazminat hesaplama - ARS HUKUK"
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.arshukukburosu.com/iskaza-tazminat"
        />
        <meta
          property="og:title"
          content="İŞ KAZASI TAZMİNAT HESAPLAMA | ARS HUKUK"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="İş kazası tazminat hesaplama - ARS HUKUK"
        />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content="https://www.arshukukburosu.com/iskaza-tazminat"
        />
      </Helmet>

      <WhiteNavbar navbarSelection={"iskaza-tazminat"} />
      <br></br>
      <br></br>
      <br></br>
      <br></br>

      <div>
        <Container style={{ fontFamily: "Nucleo Outline" }}>
          <div>
            <br />
            <h2
              className="ml-auto mr-auto text-center"
              style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <b>İŞ KAZASI TAZMİNAT HESAPLAMA</b>
            </h2>
            <p
              className="text-center"
              style={{ maxWidth: "700px", margin: "16px auto 0" }}
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              Tahmini tazminat tutarını hesaplayın (resmi değildir)
            </p>
            <br />
          </div>

          {/* Form veya Sonuç */}
          {formGosterildi ? (
            <div
              className="card"
              style={{
                borderRadius: "12px",
                border: "none",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                marginBottom: "24px",
              }}
              data-aos="zoom-in"
              data-aos-duration="1000"
            >
              <div
                style={{
                  background: "#123274",
                  padding: "16px 24px",
                  color: "white",
                }}
              >
                <h4
                  style={{
                    color: "white",
                    fontSize: "1.2rem",
                    fontWeight: 600,
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FaCalculator
                    style={{ marginRight: "12px", opacity: 0.9 }}
                  />
                  TAZMİNAT HESAPLAMA FORMU
                </h4>
              </div>

              <CardBody style={{ padding: "32px" }}>
                {hata && (
                  <Alert color="danger" className="mb-4 fw-bold">
                    <FaTimesCircle className="me-2" /> {hata}
                  </Alert>
                )}

                <Alert color="info" className="mb-4">
                  <FaInfoCircle className="me-2" />
                  Zorunlu alanlar işaretlenmiştir. Adım adım ilerleyin ve{" "}
                  <strong>Hesapla</strong> butonuna basın.
                </Alert>

                <Form onSubmit={handleSubmit}>
                  {/* Kişisel Bilgiler */}
                  <Row>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="cinsiyet"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Cinsiyet <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="select"
                          name="cinsiyet"
                          id="cinsiyet"
                          value={formData.cinsiyet}
                          onChange={handleChange}
                          required
                          invalid={!!validationErrors.cinsiyet}
                          style={{
                            padding: "1rem 1.25rem",
                            borderColor: "#e9ecef",
                            fontSize: "1rem",
                            borderRadius: "9999px",
                          }}
                        >
                          <option value="">-- Seçiniz --</option>
                          <option value="erkek">Erkek</option>
                          <option value="kadın">Kadın</option>
                        </Input>
                        {validationErrors.cinsiyet && (
                          <div className="text-danger mt-1 small">
                            <FaTimesCircle className="me-1" />
                            {validationErrors.cinsiyet}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="yas"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Yaş <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="number"
                          name="yas"
                          id="yas"
                          value={formData.yas}
                          onChange={handleChange}
                          placeholder="Örn: 35"
                          required
                          invalid={!!validationErrors.yas}
                          style={{
                            padding: "1rem 1.25rem",
                            borderColor: "#e9ecef",
                            fontSize: "1rem",
                            borderRadius: "9999px",
                          }}
                        />
                        {validationErrors.yas && (
                          <div className="text-danger mt-1 small">
                            <FaTimesCircle className="me-1" />
                            {validationErrors.yas}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Telefon */}
                  <Row>
                    <Col md={12}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="telefon"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Telefon Numarası{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="tel"
                          id="telefon"
                          name="telefon"
                          value={formData.telefon}
                          onChange={handleChange}
                          placeholder="Örn: 0555 555 55 55"
                          required
                          pattern="[0-9]{10,11}"
                          invalid={!!validationErrors.telefon}
                          style={{
                            padding: "1rem 1.25rem",
                            borderColor: "#e9ecef",
                            fontSize: "1rem",
                            borderRadius: "9999px",
                          }}
                        />
                        {validationErrors.telefon && (
                          <div className="text-danger mt-1 small">
                            <FaTimesCircle className="me-1" />{" "}
                            {validationErrors.telefon}
                          </div>
                        )}
                        <small
                          style={{
                            fontSize: "0.85rem",
                            color: "#6c757d",
                            marginTop: "8px",
                            display: "block",
                          }}
                        >
                          Size ulaşabileceğimiz telefon numarası
                        </small>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Gelir ve Oranlar */}
                  <Row>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="gelir"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Aylık Net Gelir (TL){" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <InputGroup>
                          <Input
                            type="number"
                            name="gelir"
                            id="gelir"
                            value={formData.gelir}
                            onChange={handleChange}
                            placeholder="Örn: 15000"
                            required
                            invalid={!!validationErrors.gelir}
                            style={{
                              padding: "1rem 1.25rem",
                              borderColor: "#e9ecef",
                              fontSize: "1rem",
                              borderRadius: "9999px 0 0 9999px",
                            }}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderColor: "#e9ecef",
                              color: "#495057",
                              fontWeight: 600,
                              padding: "1rem 1rem",
                              borderRadius: "0 9999px 9999px 0",
                            }}
                          >
                            ₺
                          </InputGroupText>
                        </InputGroup>
                        {validationErrors.gelir && (
                          <div className="text-danger mt-1 small">
                            <FaTimesCircle className="me-1" />
                            {validationErrors.gelir}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="maluliyetOrani"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Maluliyet Oranı (%){" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <InputGroup>
                          <Input
                            type="number"
                            name="maluliyetOrani"
                            id="maluliyetOrani"
                            value={formData.maluliyetOrani}
                            onChange={handleChange}
                            placeholder="Örn: 40"
                            required
                            invalid={!!validationErrors.maluliyetOrani}
                            style={{
                              padding: "1rem 1.25rem",
                              borderColor: "#e9ecef",
                              fontSize: "1rem",
                              borderRadius: "9999px 0 0 9999px",
                            }}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderColor: "#e9ecef",
                              color: "#495057",
                              fontWeight: 600,
                              padding: "1rem 1rem",
                              borderRadius: "0 9999px 9999px 0",
                            }}
                          >
                            %
                          </InputGroupText>
                        </InputGroup>
                        {validationErrors.maluliyetOrani && (
                          <div className="text-danger mt-1 small">
                            <FaTimesCircle className="me-1" />
                            {validationErrors.maluliyetOrani}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="isverenKusurOrani"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          İşveren Kusur Oranı (%)
                        </Label>
                        <InputGroup>
                          <Input
                            type="number"
                            name="isverenKusurOrani"
                            id="isverenKusurOrani"
                            value={formData.isverenKusurOrani}
                            onChange={handleChange}
                            placeholder="Örn: 70"
                            style={{
                              padding: "1rem 1.25rem",
                              borderColor: "#e9ecef",
                              fontSize: "1rem",
                              borderRadius: "9999px 0 0 9999px",
                            }}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderColor: "#e9ecef",
                              color: "#495057",
                              fontWeight: 600,
                              padding: "1rem 1rem",
                              borderRadius: "0 9999px 9999px 0",
                            }}
                          >
                            %
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="calisanKusurOrani"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Çalışan Kusur Oranı (%)
                        </Label>
                        <InputGroup>
                          <Input
                            type="number"
                            name="calisanKusurOrani"
                            id="calisanKusurOrani"
                            value={formData.calisanKusurOrani}
                            onChange={handleChange}
                            placeholder="Örn: 30"
                            style={{
                              padding: "1rem 1.25rem",
                              borderColor: "#e9ecef",
                              fontSize: "1rem",
                              borderRadius: "9999px 0 0 9999px",
                            }}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderColor: "#e9ecef",
                              color: "#495057",
                              fontWeight: 600,
                              padding: "1rem 1rem",
                              borderRadius: "0 9999px 9999px 0",
                            }}
                          >
                            %
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Butonlar */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                      marginTop: "24px",
                      gap: "16px",
                    }}
                  >
                    <Button
                      type="button"
                      onClick={formuTemizle}
                      size="lg"
                      style={{
                        backgroundColor: "white",
                        borderColor: "#6c757d",
                        color: "#6c757d",
                        padding: ".75rem 1.5rem",
                        fontWeight: 600,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                      className="shadow-sm"
                    >
                      <FaTrash /> Formu Temizle
                    </Button>

                    <Button
                      type="submit"
                      size="lg"
                      disabled={loading}
                      style={{
                        backgroundColor: "#123274",
                        borderColor: "#123274",
                        padding: ".75rem 2rem",
                        fontWeight: 600,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                      className="shadow"
                    >
                      {loading ? (
                        <>
                          <Spinner size="sm" /> Hesaplanıyor...
                        </>
                      ) : (
                        <>
                          <FaCalculator /> TAZMİNAT HESAPLA
                        </>
                      )}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </div>
          ) : (
            <>
              {sonuc && (
                <Card
                  style={{
                    borderRadius: "12px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                    border: "none",
                    overflow: "hidden",
                    backgroundColor: "white",
                    marginBottom: "24px",
                  }}
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <div
                    style={{
                      background: "#123274",
                      padding: "16px 24px",
                      color: "white",
                    }}
                  >
                    <h4
                      style={{
                        color: "white",
                        fontSize: "1.2rem",
                        fontWeight: 600,
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <FaCalculator
                        style={{ marginRight: "12px", opacity: 0.9 }}
                      />
                      HESAPLAMA SONUCU
                    </h4>
                  </div>

                  <CardBody style={{ padding: "32px" }}>
                    <div className="text-center mb-3">
                      <h4
                        style={{
                          fontSize: "1.4rem",
                          fontWeight: 800,
                          color: "#344767",
                          marginBottom: "1rem",
                        }}
                      >
                        TOPLAM TAZMİNAT TUTARI
                      </h4>
                      <Badge color="light" pill className="px-4 py-2">
                        Rapor No: {sonuc.raporNo}
                      </Badge>
                    </div>

                    <Row className="g-3 mb-3">
                      <Col md={4}>
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #eaecef",
                            borderRadius: 12,
                            padding: "1.1rem 1.2rem",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: ".95rem",
                              color: "#6c757d",
                              fontWeight: 800,
                              textTransform: "uppercase",
                              marginBottom: 6,
                            }}
                          >
                            Maddi Tazminat
                          </div>
                          <div
                            style={{
                              fontSize: "1.6rem",
                              fontWeight: 900,
                              color: "#123274",
                            }}
                          >
                            {sonuc.tazminatDetaylari.maddiTazminat.toLocaleString(
                              "tr-TR"
                            )}{" "}
                            ₺
                          </div>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #eaecef",
                            borderRadius: 12,
                            padding: "1.1rem 1.2rem",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: ".95rem",
                              color: "#6c757d",
                              fontWeight: 800,
                              textTransform: "uppercase",
                              marginBottom: 6,
                            }}
                          >
                            Manevi Tazminat
                          </div>
                          <div
                            style={{
                              fontSize: "1.6rem",
                              fontWeight: 900,
                              color: "#123274",
                            }}
                          >
                            {sonuc.tazminatDetaylari.maneviTazminat.toLocaleString(
                              "tr-TR"
                            )}{" "}
                            ₺
                          </div>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #eaecef",
                            borderRadius: 12,
                            padding: "1.1rem 1.2rem",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: ".95rem",
                              color: "#6c757d",
                              fontWeight: 800,
                              textTransform: "uppercase",
                              marginBottom: 6,
                            }}
                          >
                            Toplam
                          </div>
                          <div
                            style={{
                              fontSize: "1.6rem",
                              fontWeight: 900,
                              color: "#198754",
                            }}
                          >
                            {sonuc.tazminatDetaylari.toplamTazminat.toLocaleString(
                              "tr-TR"
                            )}{" "}
                            ₺
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {/* Detay Tabloları */}
                    <Row className="mt-4">
                      <Col md={6} className="mb-3">
                        <h5 className="mb-3">Hesaplama Parametreleri</h5>
                        <Table bordered responsive className="bg-white">
                          <tbody>
                            <tr>
                              <th className="bg-light" width="40%">
                                Yaş
                              </th>
                              <td>{sonuc.hesaplamaBilgileri.yas} yıl</td>
                            </tr>
                            <tr>
                              <th className="bg-light">Cinsiyet</th>
                              <td>
                                {sonuc.hesaplamaBilgileri.cinsiyet === "erkek"
                                  ? "Erkek"
                                  : "Kadın"}
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-light">Telefon</th>
                              <td>{sonuc.hesaplamaBilgileri.telefon}</td>
                            </tr>
                            <tr>
                              <th className="bg-light">Aylık Gelir</th>
                              <td>
                                {(+sonuc.hesaplamaBilgileri.gelir).toLocaleString(
                                  "tr-TR"
                                )}{" "}
                                ₺
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-light">Maluliyet Oranı</th>
                              <td>
                                %{sonuc.hesaplamaBilgileri.maluliyetOrani}
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-light">İşveren Kusur Oranı</th>
                              <td>
                                %{sonuc.hesaplamaBilgileri.isverenKusurOrani}
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-light">Çalışan Kusur Oranı</th>
                              <td>
                                %{sonuc.hesaplamaBilgileri.calisanKusurOrani}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                      <Col md={6} className="mb-3">
                        <h5 className="mb-3">Tazminat Detayları</h5>
                        <Table bordered responsive className="bg-white">
                          <tbody>
                            <tr>
                              <th className="bg-light">Maddi Tazminat</th>
                              <td>
                                {sonuc.tazminatDetaylari.maddiTazminat.toLocaleString(
                                  "tr-TR"
                                )}{" "}
                                ₺
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-light">Manevi Tazminat</th>
                              <td>
                                {sonuc.tazminatDetaylari.maneviTazminat.toLocaleString(
                                  "tr-TR"
                                )}{" "}
                                ₺
                              </td>
                            </tr>
                            <tr className="bg-light">
                              <th>Aylık Ödeme (5 Yıl)</th>
                              <td>
                                {sonuc.tazminatDetaylari.aylikOdeme.toLocaleString(
                                  "tr-TR"
                                )}{" "}
                                ₺
                              </td>
                            </tr>
                            <tr className="bg-primary text-white">
                              <th>TOPLAM</th>
                              <td>
                                {sonuc.tazminatDetaylari.toplamTazminat.toLocaleString(
                                  "tr-TR"
                                )}{" "}
                                ₺
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>

                    {/* Butonlar */}
                    <div
                      className="d-flex justify-content-center mt-4"
                      style={{ gap: 12 }}
                    >
                      <Button
                        onClick={sonucuYazdir}
                        size="lg"
                        style={{
                          backgroundColor: "white",
                          borderColor: "#6c757d",
                          color: "#6c757d",
                          padding: ".75rem 1.5rem",
                          fontWeight: 600,
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        className="shadow-sm"
                      >
                        <FaPrint /> Raporu Yazdır
                      </Button>
                      <Button
                        onClick={yeniHesaplamayap}
                        size="lg"
                        style={{
                          backgroundColor: "#123274",
                          borderColor: "#123274",
                          padding: ".75rem 1.5rem",
                          fontWeight: 600,
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        className="shadow"
                      >
                        <FaCalculator /> Yeni Hesaplama
                      </Button>
                    </div>

                    <div
                      style={{
                        textAlign: "center",
                        marginTop: 12,
                        color: "#6c757d",
                        fontWeight: 700,
                      }}
                    >
                      Rapor No: {sonuc.raporNo} | {currentDate} tarihinde{" "}
                      {currentUser} tarafından oluşturulmuştur.
                    </div>
                  </CardBody>
                </Card>
              )}
            </>
          )}
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default IsKazaTazminatHesaplama;